import router from "@/router";
import store from "@/store";
import constantRoutes from "@/router/constantRoutes";


const whiteList = ["/","404"];

router.beforeEach(async (to, from, next) => {
    let token = store.getters.token;
    setTitle(to.meta.title);

    if (token) {
        if (to.name === 'login') {
            login_out();
            next({ name: 'login' })
        }else {
            if (store.getters.roles.length === 0) {

                let userInfo = await store.dispatch("getUserInfo").catch(err => {
                    return console.error("getUserInfo",err);
                });
                if (!userInfo) {
                    login_out();
                    next({ name: 'login' });
                    return;
                }
                let accessRoutes = await store.dispatch("GenerateRoutes").catch(err => {
                    return console.error("accessRoutes",err);
                });

                (accessRoutes || []).forEach(item => {
                    router.addRoute(item)
                });

                let arr = (router.getRoutes() || []).filter(item => item.path === to.path || matchPath(to.path, item.path));
                // let arr1 = (router.getRoutes() || []).filter(item => pathToRegexp(item.path).exec(to.path));
                if (arr.length > 0 && router.hasRoute(arr[0].name)) {
                    next({ ...to, replace: true });
                }else {
                    login_out();
                    next({ name: 'login' });
                }
            } else {
                next();
            }
        }


    } else if (to.name === "login") {
        login_out();
        return next();
    } else if (to.name === "404") {
        return next();
    } else if (whiteList.includes(to.path)) {
        return next();
    } else {
        login_out();
        return next({ name: 'login' })
    }

})

function matchPath(path, route) {
    const pathParts = path.split('/')
    const routeParts = route.split('/')

    if (pathParts.length !== routeParts.length) {
        return false
    }

    for (let i = 0; i < routeParts.length; i++) {
        if (routeParts[i] === '*') {
            return true
        } else if (routeParts[i].startsWith(':')) {
            // Handle path parameters
            continue
        } else if (pathParts[i] !== routeParts[i]) {
            return false
        }
    }
    return true
}

function setTitle(title) {
    if (title) {
        document.title = title
    } else {
        document.title = "御锦产品培训平台"
    }
}

function login_out() {
    store.commit("SET_TOKEN","");
    store.commit("SET_PERMISSIONS","");
    store.commit("SET_ROLES","");
    let arr = (constantRoutes || []).map(item => item.name);

    (router.getRoutes() || []).forEach(item => {
        if (!arr.includes(item.name)) {
            // console.log(router.hasRoute(item.name))
            if (router.hasRoute(item.name)) {
                router.removeRoute(item.name)
            }
        }
    });
}
